import { ThunkDispatch } from "@reduxjs/toolkit";
import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {useSnackbar} from "notistack";
import CustomToast from "components/CustomToast";
import { getDetailTalent, getOptionsRelatedTalent, setActionStatus,
  clearSelectedTalent, searchReferrerTalent, setCancelTalentStatus,
  setIsPanelDetailTalentOpen, updateTalentInfo, getTalentTagsPanel,
  setGlobalSearchTalentFormData, setIsClickSearch, setSearchTagResult
} from "reducers/companyTalent";
import { setIsFromTagsList } from "reducers/talentTag";
import {setOpenDetailTalentPanel} from '../../../../reducers/companyHome'
import {useNavigate} from "react-router-dom";
import CustomIconButton from "../../../../components/CustomIconButton";
import CustomButton from "../../../../components/CustomButton";
import { MESSAGE_SEND_FROM, STAFF_TYPE } from "../../../../constants/index";
import TalentTagsPanel from "../TalentTagsPanel";
import { getItemsDay, getItemsMonth, getItemsYear } from "../../../../utils/util";
import { validateEmail } from "utils/validation";
import BasicInformationSection from "./BasicInformationSection";
import CareerProfileSection from "./CareerProfileSection";
import JobPreferencesSection from "./JobPreferencesSection";
import CancelTalentModal from "./CancelTalentModal";

interface ModalProps {
  onClose: () => void;
  open?: boolean;
  onScreen?:string;
}

const TalentDetailPanel: React.FC<ModalProps> = ({ onClose, open , onScreen=MESSAGE_SEND_FROM.CHAT}) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const navigate = useNavigate();
  const location = useLocation();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const {staffInfo} = useSelector((state: any) => state.currentUser);
  const { selectedTalent, talentOptionsRelatedData, isPanelDetailTalentOpen, globalSearchTalentFormData,
    referrerTalentOptions, cancelTalentStatus, actionStatus, actionName, isSuccess, message, resumeLinks
  } = useSelector((state: any) => state.companyTalent,);
  const { isFromTagsList, isOpenSearchTagsPanel } = useSelector((state: any) => state.talentTag);
  const [formData, setFormData] = useState(
    { 
      id: null, type: null, email: null, agent_info: null, ownership_period_start_date: null,
      ownership_period_end_date: null, note: null, referral_hiring: null,
      employee_number: null, leave_company_year: null,
      leave_company_month: null, leave_company_day: null, is_referred: false, referrer_talent_id: null,
      referrer_talent: null, related_links: [],
    }
  );
  const [talentTypes, setTalentTypes] = useState([]);
  const [talentRanks, setTalentRanks] = useState([]);
  const [isTagsPanel, setIsTagsPanel] = useState(false);
  const [referrerTalentSearchText, setReferrerTalentSearchText] = useState('');
  const [isOpenModalCancelTalent, setIsOpenModalCancelTalent] = useState(false);
  
  const yearOptions = getItemsYear(null);
  const monthOptions = getItemsMonth();
  const [dayOptions, setDayOptions] = useState([{id: -1, name: ""}]);
  
  useEffect(() => {
    // Get options related talent
    dispatch(getOptionsRelatedTalent(""));

    // Get data referrer talent
    handleChangeReferrerTalentSearchText("");
    setDayOptions(getItemsDay());
  }, []);

  useEffect(() => {
    if (selectedTalent?.talent?.id) {
      dispatch(getTalentTagsPanel({id: Number(selectedTalent?.talent?.id)}));
    }
  }, [selectedTalent]);

  useEffect(() => {
    if (open === true) {
      dispatch(setIsPanelDetailTalentOpen(true));
    }
  }, [open]);

  useEffect(() => {
    if (isFromTagsList && isOpenSearchTagsPanel) {
      setIsTagsPanel(true);
      setTimeout(() => {
        dispatch(setIsFromTagsList(false));
      }, 2000);
    }
  }, [location.state]);

  useEffect(() => {
    if (actionStatus === 'fulfilled' && actionName === 'updateTalentInfo') {
      showToast('メッセージ', message, isSuccess ? "success" : "error");
      dispatch(setActionStatus('idle'));
    }

    if (actionStatus === 'fulfilled' && actionName === 'updateTalentResume') {
      showToast('メッセージ', message, isSuccess ? "success" : "error");
      dispatch(setActionStatus('idle'));

      setFormData({
        ...formData,
        id: null, // reset id to prevent auto calling updateTalentInfo API
        related_links: resumeLinks
      })
    }
  }, [actionStatus, actionName]);

  const handleDateLeaveCompany = (dateInput: any) => {
    let leave_company_year = null
    let leave_company_month = null
    let leave_company_day = null

    if(dateInput) {
      try {
        const newDate = new Date(dateInput)
        leave_company_year = newDate.getFullYear()
        leave_company_month = newDate.getMonth() + 1
        leave_company_day = newDate.getDate()
      } catch (error) {
        console.warn("Invalid date: ", dateInput);
      }
    }

    return {
      leave_company_year: leave_company_year,
      leave_company_month: leave_company_month,
      leave_company_day: leave_company_day
    }
  };

  useEffect(() => {
    if (!isFromTagsList) {
      setIsTagsPanel(false);
    }
    
    let talent_type = null
    if (talentOptionsRelatedData.talent_types) {
      setTalentTypes(talentOptionsRelatedData.talent_types)
      talent_type = getObjectById(selectedTalent.talent_type, talentOptionsRelatedData.talent_types)
    }

    let recruitment_rank = null
    if (talentOptionsRelatedData.recruitment_ranks) {
      setTalentRanks(talentOptionsRelatedData.recruitment_ranks)
      recruitment_rank = getObjectById(selectedTalent.recruitment_rank, talentOptionsRelatedData.recruitment_ranks)
    }

    setFormData({
      ...formData,
      id: null, 
      type: talent_type,
      email: selectedTalent?.talent?.email || "",
      agent_info: selectedTalent.agent_info || "",
      ownership_period_start_date: selectedTalent.ownership_period_start_date,
      ownership_period_end_date: selectedTalent.ownership_period_end_date,
      recruitment_rank: recruitment_rank,
      referral_hiring: selectedTalent?.referral_hiring || "",
      note: selectedTalent.note || "",
      leave_company_year: getObjectById(selectedTalent.leave_company_year, yearOptions),
      leave_company_month: getObjectById(selectedTalent.leave_company_month, monthOptions),
      leave_company_day: getObjectById(selectedTalent.leave_company_day, dayOptions),
      employee_number: selectedTalent?.employee_number || "",
      is_referred: selectedTalent.is_referred,
      referrer_talent_id: selectedTalent?.referrer_talent_id,
      referrer_talent: {id: selectedTalent?.referrer_talent?.value, name: selectedTalent?.referrer_talent?.label},
      related_links: selectedTalent?.resumes?.length > 0 ? selectedTalent.resumes : [{id: null, file_url: "", file_name: ""}]
    })

    if(selectedTalent.leave_company_year && selectedTalent.leave_company_month) {
      const dataDate = getItemsDay(
        selectedTalent.leave_company_year,
        selectedTalent.leave_company_month,
      );
      setDayOptions(dataDate);
    }
    
  }, [talentOptionsRelatedData, selectedTalent]);

  useEffect(() => {
    submitUpdateTalentInfo()
  }, [formData]);

  useEffect(() => {
    if (cancelTalentStatus === 'fulfilled') {
      showToast('メッセージ', message, isSuccess ? "success" : "error");
      dispatch(getDetailTalent({ id: selectedTalent?.id }));
      dispatch(setCancelTalentStatus("idle"));
    }
  }, [cancelTalentStatus]);

  const showToast = (title: any, mes: any, variant: any) => {
    enqueueSnackbar("I love snacks.", {
      content: (key) => (
        <CustomToast title={title} message={mes} variant={variant} snackbarKey={key} closeSnackbar={closeSnackbar} />
      ),
    });
  };

  onClose = () => {
    dispatch(setIsPanelDetailTalentOpen(false));
    dispatch(clearSelectedTalent());
    dispatch(setOpenDetailTalentPanel(false));
  };

  const handleChangeForm = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      id: null, 
      [name]: value,
    }));
  };
  
  const handleBlurInput = (e: any) => {
    const { name, value } = e.target;

    // Save info
    setFormData((prev) => ({
      ...prev,
      id: selectedTalent?.id,
      [name]: value.trim(),
    }));
  };

  const handleBlurEmailInput = (e: any) => {
    const { name, value } = e.target;
    
    // Validate email
    const validateEmailRes = validateEmail(value.trim());
    if(validateEmailRes != true) {
      showToast('メッセージ', validateEmailRes, "error");
      return
    }

    // Save info
    setFormData((prev) => ({
      ...prev,
      id: selectedTalent?.id,
      [name]: value.trim(),
    }));
  }

  const submitUpdateTalentInfo = () => {
    if(!formData?.id) {
      return 
    }
    const data = {
      id: selectedTalent?.id,
      email: formData.email,
      type: formData.type?.id ? formData.type?.id : null,
      recruitment_rank: formData.recruitment_rank?.id ? formData.recruitment_rank?.id : null,
      referral_hiring: formData.referral_hiring,
      note: formData.note,
      agent_info: formData.agent_info,
      ownership_period_start_date: formData.ownership_period_start_date ? formData.ownership_period_start_date : null,
      ownership_period_end_date: formData.ownership_period_end_date ? formData.ownership_period_end_date : null,
      employee_number: formData.employee_number,
      is_referred: formData.is_referred,
      referrer_talent_id: formData.referrer_talent_id,
      leave_company_year: formData.leave_company_year?.id ? formData.leave_company_year?.id : null,
      leave_company_month: formData.leave_company_month?.id ? formData.leave_company_month?.id : null,
      leave_company_day: formData.leave_company_day?.id ? formData.leave_company_day?.id : null,
    }
    dispatch(updateTalentInfo({requestBody: data}));
  };

  const getObjectById = (id: any, items: any) => {
    if(!id || !items || items.length == 0) {
      return null
    }
    for(let item of items) {
      if(item.id == id) {
        return item;
      }
    }
    return null;
  };

  const handleSelectTag = (tag) => {
    dispatch(setIsPanelDetailTalentOpen(false));
    const data = {
      ...globalSearchTalentFormData,
      tags: [{id: tag?.id, name: tag?.title}]
    }
    dispatch(setGlobalSearchTalentFormData(data))
    dispatch(setIsClickSearch(true));
    dispatch(setSearchTagResult({status: 1, error: null}));
    navigate('/company/talent', { state: { isFromDetail: true } })
  };

  const getValueByObject = (object: any) => {
    if (!object) {
      return null;
    }
    return object.id;
  };

  const changeYearLeaveCom = (value: any, name: any) => {
    let leave_company_day = formData.leave_company_day

    if(value && getValueByObject(value)
      && formData.leave_company_month && getValueByObject(formData.leave_company_month)) {
      const dataDate = getItemsDay(
        getValueByObject(value),
        getValueByObject(formData.leave_company_month),
      );
      setDayOptions(dataDate);

      if(leave_company_day && !dataDate.some(item => item.id === leave_company_day.id)) {
        leave_company_day = null
      }
    }

    setFormData((prev) => ({
      ...prev,
      id: selectedTalent?.id, 
      [name]: value,
      leave_company_day: leave_company_day
    }));
  };

  const toggleTalentTagPanel = (value) => {
    setIsTagsPanel(value);
  }
  
  const changeMonthLeaveCom = (value: any, name: any) => {
    let leave_company_day = formData.leave_company_day
    if(formData.leave_company_year && getValueByObject(formData.leave_company_year)
      && value && getValueByObject(value)) {
      const dataDate = getItemsDay(
        getValueByObject(formData.leave_company_year),
        getValueByObject(value),
      );
      setDayOptions(dataDate);

      if(leave_company_day && !dataDate.some(item => item.id === leave_company_day.id)) {
        leave_company_day = null
      }
    }

    setFormData((prev) => ({
      ...prev,
      id: selectedTalent?.id, 
      [name]: value,
      leave_company_day: leave_company_day
    }));
  };

  const handleChangeReferrerTalentSearchText = (value: any) => {
    setReferrerTalentSearchText(value);
    dispatch(searchReferrerTalent({ searchText: value }));
  };

  useEffect(() => {
    dispatch(searchReferrerTalent({searchText: referrerTalentSearchText}));
  }, [referrerTalentSearchText]);

  return (
    <>
    { isPanelDetailTalentOpen && (
      <div className="min-w-[42rem] max-w-[42rem] bg-white rounded-2xl pt-3 alu-panel-box-shadow h-full flex flex-col">
        {!isTagsPanel && <div className="px-4 mb-1">
          <CustomIconButton onClick={onClose} customStyle="ml-auto mb-1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <g clipPath="url(#clip0_8574_265)">
                <path
                  d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                  fill="currentColor"
                />
              </g>
              <defs>
                <clipPath id="clip0_8574_265">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </CustomIconButton>
        </div>}
        {!isTagsPanel ? <>
          <div className="overflow-y-auto custom-scrollbar h-[calc(100%-40px)] px-4 pb-6">
            <BasicInformationSection
              formData={formData}
              talentTypes={talentTypes}
              talentRanks={talentRanks}
              handleBlurEmailInput={handleBlurEmailInput}
              handleChangeForm={handleChangeForm}
              handleBlurInput={handleBlurInput}
              toggleTalentTagPanel={toggleTalentTagPanel}
              handleSelectTag={handleSelectTag}
              setFormData={setFormData}
            />
            <CareerProfileSection
              formData={formData}
              dayOptions={dayOptions}
              setFormData={setFormData}
              handleChangeForm={handleChangeForm}
              handleBlurInput={handleBlurInput}
              referrerTalentOptions={referrerTalentOptions}
              referrerTalentSearchText={referrerTalentSearchText}
              setReferrerTalentSearchText={setReferrerTalentSearchText}
              changeYearLeaveCom={changeYearLeaveCom}
              changeMonthLeaveCom={changeMonthLeaveCom}
            />
            <JobPreferencesSection />
            {selectedTalent?.is_active &&
              <div className="mt-[4rem]">
                <CustomButton variant="danger_text" type="button" 
                  onClick={() => setIsOpenModalCancelTalent(true)}
                  disabled={staffInfo?.type == STAFF_TYPE.GENERAL}>
                  退会手続き
                </CustomButton>
              </div>
            }
          </div>
          {isOpenModalCancelTalent &&
            <CancelTalentModal 
              open={isOpenModalCancelTalent}
              onClose={() => setIsOpenModalCancelTalent(false)}
            />
          }
        </>
        : 
        <TalentTagsPanel onClose={onClose} setIsTagsPanel={setIsTagsPanel} />
        }
      </div>
    )
  }
  </>
  );
};

export default TalentDetailPanel;
